var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"icons",staticClass:"icons-container",style:({ left: _vm.left + 'px', top: _vm.top + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }